const EMAIL = "mfaby.digit@gmail.com";
const COMPANY = "Croque-Mitaine";
const SIRET = "10645597500016";

function LegalShell({ title, updated, children, testId }) {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-12 lg:py-16" data-testid={testId}>
      <p className="eyebrow mb-2">Informations légales</p>
      <h1 className="font-display text-3xl sm:text-4xl font-black uppercase text-stone-100 mb-2">{title}</h1>
      <p className="text-xs text-stone-500 mb-10">Dernière mise à jour : {updated}</p>
      <div className="prose-legal space-y-6 text-stone-300 leading-relaxed text-sm">{children}</div>
      <p className="mt-12 p-4 rounded-xl bg-amber-500/5 border border-amber-500/20 text-xs text-stone-400">
        ℹ️ Pour une mise en ligne définitive, complétez les éléments restants (adresse postale, forme
        juridique, hébergeur) avec vos informations officielles.
      </p>
    </div>
  );
}

function H({ children }) {
  return <h2 className="font-display text-xl font-bold text-amber-400 mt-8 mb-2">{children}</h2>;
}

export function CGV() {
  return (
    <LegalShell title="Conditions Générales de Vente" updated="Juin 2026" testId="cgv-page">
      <p>Les présentes CGV régissent les ventes conclues sur le site {COMPANY} entre le vendeur et tout client.</p>
      <H>Article 1 — Produits</H>
      <p>Les produits proposés sont des articles de déguisement, de décoration et des accessoires à thème Halloween. Les photographies sont non contractuelles.</p>
      <H>Article 2 — Prix</H>
      <p>Les prix sont indiqués en euros (€) toutes taxes comprises. {COMPANY} se réserve le droit de modifier ses prix à tout moment, les produits étant facturés sur la base des tarifs en vigueur au moment de la commande.</p>
      <H>Article 3 — Commande & Stock</H>
      <p>Les offres promotionnelles et les quantités affichées comme « stock limité » sont valables dans la limite des stocks disponibles. Une commande n'est définitive qu'après confirmation du paiement.</p>
      <H>Article 4 — Paiement</H>
      <p>Le paiement s'effectue en ligne de manière sécurisée par carte bancaire via notre prestataire Stripe. La commande est validée après acceptation du paiement.</p>
      <H>Article 5 — Livraison</H>
      <p>Les produits sont expédiés à l'adresse indiquée lors de la commande, généralement sous 48h ouvrées. Les délais de livraison sont donnés à titre indicatif. La livraison est offerte dès 40 € d'achat.</p>
      <H>Article 6 — Droit de rétractation</H>
      <p>Conformément au Code de la consommation, le client dispose d'un délai de 14 jours à compter de la réception pour exercer son droit de rétractation, sans avoir à justifier de motifs. Les produits doivent être retournés neufs et non utilisés.</p>
      <H>Article 7 — Garanties</H>
      <p>Les produits bénéficient de la garantie légale de conformité et de la garantie contre les vices cachés.</p>
      <H>Article 8 — Service client</H>
      <p>Pour toute question, contactez-nous à l'adresse <a href={`mailto:${EMAIL}`} className="text-amber-400">{EMAIL}</a>.</p>
    </LegalShell>
  );
}

export function MentionsLegales() {
  return (
    <LegalShell title="Mentions Légales" updated="Juin 2026" testId="mentions-page">
      <H>Éditeur du site</H>
      <p>Le site {COMPANY} est édité par {COMPANY}, entreprise immatriculée sous le numéro SIRET <strong className="text-stone-200">{SIRET}</strong>.</p>
      <p>Email : <a href={`mailto:${EMAIL}`} className="text-amber-400">{EMAIL}</a></p>
      <H>Directeur de la publication</H>
      <p>[Nom du responsable à compléter].</p>
      <H>Hébergement</H>
      <p>Le site est hébergé par [nom et adresse de l'hébergeur à compléter].</p>
      <H>Propriété intellectuelle</H>
      <p>L'ensemble des contenus du site (textes, visuels, logos) est protégé par le droit de la propriété intellectuelle. Toute reproduction sans autorisation est interdite.</p>
      <H>Responsabilité</H>
      <p>{COMPANY} s'efforce d'assurer l'exactitude des informations diffusées mais ne saurait être tenu responsable des erreurs ou omissions.</p>
    </LegalShell>
  );
}

export function Confidentialite() {
  return (
    <LegalShell title="Politique de Confidentialité" updated="Juin 2026" testId="confidentialite-page">
      <p>{COMPANY} accorde une grande importance à la protection de vos données personnelles, conformément au Règlement Général sur la Protection des Données (RGPD).</p>
      <H>Données collectées</H>
      <p>Nous collectons les informations nécessaires au traitement de vos commandes : nom, email, adresse de livraison et informations de paiement (traitées de façon sécurisée par Stripe, nous ne stockons jamais vos données bancaires).</p>
      <H>Utilisation des données</H>
      <p>Vos données sont utilisées pour traiter vos commandes, assurer le suivi client et, avec votre accord, vous informer de nos offres.</p>
      <H>Conservation</H>
      <p>Les données sont conservées pendant la durée nécessaire aux finalités décrites et aux obligations légales.</p>
      <H>Vos droits</H>
      <p>Vous disposez d'un droit d'accès, de rectification, d'effacement et d'opposition sur vos données. Pour l'exercer, écrivez-nous à <a href={`mailto:${EMAIL}`} className="text-amber-400">{EMAIL}</a>.</p>
      <H>Cookies</H>
      <p>Le site utilise des cookies nécessaires à son bon fonctionnement (panier, session) et, le cas échéant, des cookies de mesure d'audience.</p>
    </LegalShell>
  );
}
